import { createContext, useContext } from 'react';

/* istanbul ignore file */
var AccordionContext = createContext({
    openIds: [],
    onToggleOpen: function () { return ({}); }
});
var useAccordionItem = function (id) {
    var _a = useContext(AccordionContext), openIds = _a.openIds, onToggleOpen = _a.onToggleOpen;
    return {
        open: openIds.includes(id),
        onToggleOpen: function () { return onToggleOpen(id); }
    };
};

export { AccordionContext, useAccordionItem };
